module.exports = __webpack_public_path__ + "static/media/member-introduction-mateusz-wojciechowski.7038d430.jpg";